/**
 * Вход через Keycloak установки (PLAN-keycloak.md, этап 2): провайдер `oidc` бэкенда на realm viva. Кнопка
 * на странице входа — только когда Keycloak подключён (viva.keycloak.url — KEYCLOAK_URL стенда).
 */
import {
  BackstageIdentityApi,
  ConfigApi,
  createApiRef,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from '@backstage/core-plugin-api';

export const keycloakAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({ id: 'auth.viva.keycloak' });

export const keycloakEnabled = (config: ConfigApi) => Boolean(config.getOptionalString('viva.keycloak.url'));
